import React from 'react';

/**
 * Practice mode + view mode selectors.
 * Pure presentational — all state is owned by the parent.
 */
export const PracticeModeSelector = ({ isKidsMode, practiceMode, setPracticeMode }) => (
  <div
    className={`p-6 ${
      isKidsMode
        ? 'bg-white rounded-3xl shadow-[0_8px_0_0_rgba(0,0,0,0.1)]'
        : 'bg-white/70 backdrop-blur-sm rounded-xl border border-stone-200'
    }`}
    data-testid="practice-mode-selector"
  >
    <h3 className="font-bold mb-3">Çalışma Modu</h3>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
      {[
        { id: 'full', label: 'Tam Pratik', icon: '🎯' },
        { id: 'listen', label: 'Sadece Dinle', icon: '👂' },
        { id: 'read', label: 'Sadece Oku', icon: '📖' },
        { id: 'mixed', label: 'Karışık', icon: '🔀' },
      ].map((mode) => (
        <button
          key={mode.id}
          onClick={() => setPracticeMode(mode.id)}
          data-testid={`practice-mode-${mode.id}`}
          className={`p-3 rounded-lg border-2 transition-all text-center ${
            practiceMode === mode.id
              ? isKidsMode
                ? 'border-green-400 bg-green-50'
                : 'border-emerald-700 bg-emerald-50'
              : 'border-gray-200 hover:border-gray-300'
          }`}
        >
          <div className="text-2xl mb-1">{mode.icon}</div>
          <div className="text-xs font-medium">{mode.label}</div>
        </button>
      ))}
    </div>
  </div>
);

export default PracticeModeSelector;
